import { Grid, Stack } from '@mui/material';

import {
  formatInstallments,
  formatInteger,
  formatPuntajePoints,
} from '../../utils/puntajeFormatters';
import MetricCard from '../common/MetricCard';
import SuggestionCard from '../common/SuggestionCard';

const DashboardOverviewTab = ({
  dashboardRows,
  selectedDashboard,
  financingInstallmentsCreated,
  isAdmin,
  onConfirmSuggestion,
  confirmLoading,
}) => (
  <Stack ml={2} borderRadius={0}>
    <Grid container spacing={2} bgcolor="white" padding={2} paddingRight={3}>
      <Grid item xs={12} sm={6} md={3}>
        <MetricCard
          title="Grupos visibles"
          value={formatInteger(dashboardRows.length)}
          subtitle="Resumen general del periodo"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MetricCard
          title="Fondo Puntaje"
          value={formatInstallments(selectedDashboard?.puntaje_balance_installments)}
          subtitle={`${formatPuntajePoints(selectedDashboard?.puntaje_balance_installments)} puntos`}
          color="success.main"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MetricCard
          title="Fondo Sorteo"
          value={formatInstallments(selectedDashboard?.sorteo_balance_installments)}
          subtitle="Saldo del grupo seleccionado"
          color="warning.main"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MetricCard
          title="Top ranking"
          value={selectedDashboard?.top_contract_number || '-'}
          subtitle={
            selectedDashboard?.top_score_installments
              ? `${formatInstallments(selectedDashboard.top_score_installments)} cuotas | ${formatPuntajePoints(selectedDashboard.top_score_installments)} puntos`
              : 'Sin ranking disponible'
          }
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MetricCard
          title="Elegibles base"
          value={formatInteger(selectedDashboard?.total_base_eligible_contracts)}
          subtitle="Contratos dentro del modulo"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MetricCard
          title="Adjudicables"
          value={formatInteger(selectedDashboard?.total_award_eligible_contracts)}
          subtitle="Sin mora del modulo"
          color="success.main"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MetricCard
          title="Morosos"
          value={formatInteger(selectedDashboard?.total_morose_contracts)}
          subtitle="Quedan fuera de sugerencias"
          color="error.main"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <MetricCard
          title="Financiamiento generado"
          value={formatInteger(financingInstallmentsCreated)}
          subtitle="Cuotas de 60 meses ya creadas"
        />
      </Grid>
    </Grid>

    <Grid container spacing={2} padding={3} bgcolor="white">
      <Grid item xs={12} md={4}>
        <SuggestionCard
          suggestion={selectedDashboard?.puntaje_suggestion}
          title="Sugerencia por Puntaje"
          isAdmin={isAdmin}
          onConfirm={() => onConfirmSuggestion(selectedDashboard?.puntaje_suggestion)}
          isLoading={confirmLoading}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <SuggestionCard
          suggestion={selectedDashboard?.sorteo_suggestion}
          title="Sugerencia por Sorteo"
          isAdmin={isAdmin}
          onConfirm={() => onConfirmSuggestion(selectedDashboard?.sorteo_suggestion)}
          isLoading={confirmLoading}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <SuggestionCard
          suggestion={selectedDashboard?.desborde_suggestion}
          title="Sugerencia por Desborde"
          isAdmin={isAdmin}
          onConfirm={() => onConfirmSuggestion(selectedDashboard?.desborde_suggestion)}
          isLoading={confirmLoading}
        />
      </Grid>
    </Grid>
  </Stack>
);

export default DashboardOverviewTab;
